(ns ycweb.app.admin.buying.rangereview.common
  (:require
   [cemerick.url :as url]
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.admin.storeplans.overview :as mult-select]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as yuc]
   [ycweb.util.date :as yud]
   [ycweb.util.urlstate :as urlstate]))

(defn filter-products [view-products variations]
  (case view-products
    :live
    (filter (comp :variation/live? :item-line/variation) variations)

    :not-live
    (filter (comp false? :variation/live? :item-line/variation) variations)

    :suggested
    (filter (comp :variation/suggested? :item-line/variation) variations)

    variations))

(defn add-selected-brands [brands selected-brands]
  (->>
    brands
    (map
      (fn [[id brand]]
        (assoc brand :brand/selected? (contains? selected-brands id))))
    (yuc/index-by :brand/id)))

(defn get-selected-brand-ids [brands-idx]
  (->>
    (vals brands-idx)
    (filter :brand/selected?)
    (map :brand/id)
    (str/join ",")))

(def review-status-class
  {:draft :is-warning
   :complete :is-note
   :approved :is-success})

(defn extract-param-brand-ids [app-atom]
  (let [brand-ids (:brand-ids (cmn/screen-params app-atom))
        brand-decode-ids (url/url-decode brand-ids)]
    (when-not (empty? brand-ids)
      (->>
        (str/split brand-decode-ids #",")
        (map trf/tonumber)))))

(rum/defc bread-crumbs < rum/reactive [app-atom page-type range-review crumb-count idx category-level]
  (if (not= crumb-count (+ idx 1))
    [:li.breadcrumbs__item
     [:a.breadcrumb__link (urlstate/href-props app-atom "rangereview" "category" {:review-uuid (:ent/uuid range-review) :category-uuid (:ent/uuid category-level)}) (:ent/display-name category-level)]]
    [:li.breadcrumbs__item
     [:span.breadcrumbs__current-text (:ent/display-name category-level)]]))

(defn filter-proposed [item]
  (let [variation (:item-line/variation item)]
    (and
      (not (:variation/delist? variation))
      (not (:variation/store-remove? variation))
      (:variation/included? variation)
      (= (or (:variation/stores-ranged variation) 0) 0))))

(defn filter-store [item]
  (let [variation (:item-line/variation item)]
    (and (:variation/stores-ranged variation) (pos? (:variation/stores-ranged variation)))))

(defn filter-variations [filter-fn variations]
  (->>
    variations
    (filter filter-fn)
    (count)))

(defn average [lst]
  (if (and lst (pos? (count lst))) (/ (reduce + lst) (count lst)) 0))

(defmethod grid/action :admin.range-review/multi-select-update
  [app-atom {:keys [entity-atom filter-selector item-selector selected-key selected-item]}]
  (swap! entity-atom update filter-selector
    (fn [current-options]
      (let [existing-option (get current-options (get selected-item item-selector))

            selected?
            (not
              (if existing-option
                (get existing-option (or selected-key :selected?))
                (get selected-item (or selected-key :selected?))))]

        (assoc-in current-options
          [(get selected-item item-selector)]
          (assoc selected-item (or selected-key :selected?) selected?))))))

(rum/defc range-review-filters < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        filters-atom (rum/cursor-in action-atom [:filters])
        brands (vals (:brands-idx (rum/react filters-atom)))

        display-name-filter-pred
        #(str/includes?
           (str/lower-case (:ent/display-name %1))
           (str/lower-case %2))]

    [:div.u-margin-bottom-30
     (headings/heading (str "Filters:") {:type :h3 :size :medium :flush true})
     [:div.u-margin-top-16.u-bg-ghost
      {:class (yuc/bem :card [:no-hover] :text-card [:small])}
      [:div
       {:class (yuc/bem :flex-grid-group [:valign-bottom :align-left :flush])}
       [:div
        {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Brands:"]
         (forms/inline-autocomplete-select
           (into
             [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
             (->>
               brands
               (filter #(:brand/selected? %))
               (map #(mult-select/multiselect-cell-selected app-atom {} {} %))))
           (sort-by :ent/display-name brands)
           {:select-style? true
            :force-open? true
            :select-fn
            #(grid/dispatch-action app-atom :admin.range-review/multi-select-update
               {:entity-atom filters-atom
                :filter-selector :brands-idx
                :item-selector :brand/id
                :selected-key :brand/selected?
                :selected-item %})
            :item-render-fn
            (partial mult-select/multiselect-cell-toggle app-atom (rum/cursor filters-atom :brands-idx)
              {:item-selector :brand/id
               :selected-key :brand/selected?})
            :filter-fn display-name-filter-pred})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-full :fluid])}
        [:div.flex-grid-content
         (buttons/button "Filter"
           #(grid/dispatch-action app-atom :admin.range-review/apply-filters
              {})
           {:primary true
            :bordered true
            :raised true
            :full true})]]]]]))

(defmethod grid/action :admin.range-review/apply-filters [app-atom _ _]
  (let [action-atom (cmn/action-cursor app-atom)
        {:keys [brands-idx]} (cmn/curact action-atom :filters)

        brand-ids
        (get-selected-brand-ids brands-idx)

        url-params
        (merge
          (cmn/screen-params app-atom)
          (yuc/maybe assoc
            {:brand-ids (yuc/presence brand-ids)}))]

    (urlstate/redirect app-atom "rangereview" (name (cmn/action-name app-atom)) url-params)))

(rum/defc rangereview-header < rum/reactive [app-atom page-type large-text?]
  (let [action-atom (cmn/action-cursor app-atom)
        category (cmn/curact action-atom :category)
        growth (cmn/curact action-atom :growth)
        category-stats (cmn/curact action-atom :category-stats)
        category-stats-prev (cmn/curact action-atom :category-stats-prev)
        fetching-history? (cmn/curact action-atom :fetching-history?)
        variations (vals (cmn/curact action-atom :variations))
        live-variations (filter-products :live variations)
        range-review (cmn/curact action-atom :range-review)
        proposed-product-count (filter-variations filter-proposed variations)
        store-product-count (filter-variations filter-store variations)
        listed-variations (remove (comp :variation/suggested? :item-line/variation) variations)
        suggested-product-count (filter-variations (comp :variation/suggested? :item-line/variation) variations)
        store-remove-count (filter-variations (comp :variation/store-remove? :item-line/variation) variations)

        avg-sellability
        (when
          listed-variations
          (->>
            listed-variations
            (map :item-line/variation)
            (mapcat (juxt :variation/online-sellability :variation/store-sellability))
            (remove nil?)
            (average)))

        prev-avg-sellability
        (when
          listed-variations
          (->>
            listed-variations
            (map :item-line/variation)
            (mapcat (juxt :variation/prev-online-sellability :variation/prev-store-sellability))
            (remove nil?)
            (average)))]

    [:div
     (range-review-filters app-atom)
     [:div
      {:class (yuc/bem :range-review-summary [(when large-text? :big-text-mode)])}
      [:div.u-do-not-print
       (when (and category (not= page-type :print))
         [:ul.breadcrumbs.u-margin-bottom-32
          [:li.breadcrumbs__item
           [:a.breadcrumb__link
            (urlstate/href-props app-atom "rangereview" "category" {:review-uuid (:ent/uuid range-review)})
            "Range Review"]]
          (concat
            (map-indexed (partial bread-crumbs app-atom page-type range-review (count (:category/bread-crumbs category))) (:category/bread-crumbs category)))])]
      (headings/heading
        (list
          (or (:ent/display-name category) (:ent/display-name range-review))
          (when (and (:cat-income category-stats) (:income-contrib category-stats))
            (str " (R" (yuc/human-readable-currency (:cat-income category-stats)) " | " (str (last (:income-contrib category-stats)) "%") ")")))
        {:type :h1
         :class "range-review-summary__heading"
         :size :large
         :flush true})
      (when category
        [:p.yc-paragraph.range-review-summary__paragraph.u-margin-top-8
         [:b "For range review: "]
         (:ent/display-name range-review)
         ;" ("
         ;(ud/date-format (:range-review/date-from range-review) "dd MMM YYYY")
         ;" - "
         ;(ud/date-format (:range-review/date-to range-review) "dd MMM YYYY")
         ;")"
         ])

      ;; Digital Version of Stats
      (when (and category-stats (or (= page-type :digital) (= page-type :product)))
        [:<>
         [:div.range-review-summary__stats.u-margin-bottom-20
          [:div.stats-table-card.u-max-width-640
           [:table.stats-table
            [:tbody
             [:tr.stats-table__row
              [:th.stats-table__th "Live product count:"]
              [:td.stats-table__td.u-text-right (:category/liveproductcount category)]]
             [:tr.stats-table__row
              [:th.stats-table__th "Live SKU count:"]
              [:td.stats-table__td.u-text-right (count live-variations)]]
             [:tr.stats-table__row
              [:th.stats-table__th "SKU Count in Stores:"]
              [:td.stats-table__td.u-text-right
               (str "Current: " store-product-count " | Proposed: " (- (+ store-product-count proposed-product-count) store-remove-count))]]
             (when (> (count (:cats category-stats)) 0)
               [:tr.stats-table__row
                [:th.stats-table__th "Income Contribution to " (first (:cats category-stats))]
                [:td.stats-table__td.u-text-right (first (:income-contrib category-stats)) "%"]])
             (when (> (count (:cats category-stats)) 1)
               [:tr.stats-table__row
                [:th.stats-table__th "Income Contribution to " (last (:cats category-stats))]
                [:td.stats-table__td.u-text-right (last (:income-contrib category-stats)) "%"]])
             [:tr.stats-table__row
              [:th.stats-table__th "Average Margin:"]
              [:td.stats-table__td.u-text-right
               "Last year: "
               (str
                 (yuc/number-format (:margin category-stats-prev) 2)
                 "% | This year: "
                 (yuc/number-format (:margin category-stats) 2)
                 "%")]]
             [:tr.stats-table__row
              [:th.stats-table__th "Average Sellability:"]
              [:td.stats-table__td.u-text-right
               "Last year: "
               [:span (yuc/maybe assoc {:class [(when fetching-history? :u-text-red)]})
                (str (yuc/number-format prev-avg-sellability 2) "%")]
               " | This year: "
               [:span (yuc/maybe assoc {:class [(when fetching-history? :u-text-red)]})
                (str (yuc/number-format avg-sellability 2) "%")]]]]]]]

         (headings/heading "Income breakdown:" {:type :h3 :size :small})
         [:table
          {:class (yuc/bem :oTable [:has-shadow])}
          [:colgroup
           [:col {:style {:min-width "240px;"}}]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]
           [:col]]
          [:thead
           [:tr
            [:th.u-min-width-240 {:scope "col"}]
            [:th {:scope "col"} "Units Last Year"]
            [:th {:scope "col"} "Units This Year"]
            [:th {:scope "col"} "Units Growth (%)"]
            [:th {:scope "col"} "Income Last Year"]
            [:th {:scope "col"} "Income This Year"]
            [:th {:scope "col"} "Income Growth (%)"]
            [:th {:scope "col"} "Income Contribution (%)"]]]
          [:tbody
           [:tr.row-status
            [:td.u-min-width-320 [:b "Online"]]
            [:td.u-text-nowrap (- (:cat-sales category-stats-prev) (:cat-store-sales category-stats-prev))]
            [:td.u-text-nowrap (- (:cat-sales category-stats) (:cat-store-sales category-stats))]
            [:td.u-text-nowrap
             (->
               (- (:cat-sales category-stats) (:cat-store-sales category-stats))
               (- (- (:cat-sales category-stats-prev) (:cat-store-sales category-stats-prev)))
               (/ (- (:cat-sales category-stats-prev) (:cat-store-sales category-stats-prev)))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (- (:cat-income category-stats-prev) (:cat-store-income category-stats-prev))))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (- (:cat-income category-stats) (:cat-store-income category-stats))))]
            [:td.u-text-nowrap
             (->
               (- (:cat-income category-stats) (:cat-store-income category-stats))
               (- (- (:cat-income category-stats-prev) (:cat-store-income category-stats-prev)))
               (/ (- (:cat-income category-stats-prev) (:cat-store-income category-stats-prev)))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap
             (->
               (:cat-income category-stats)
               (- (:cat-store-income category-stats))
               (/ (if (= (:cat-income category-stats) 0) 1 (:cat-income category-stats)))
               (* 100)
               (yuc/number-format)
               (str "%"))]]
           [:tr.row-status
            [:td.u-min-width-320 [:b "Stores"]]
            [:td.u-text-nowrap (:cat-store-sales category-stats-prev)]
            [:td.u-text-nowrap (:cat-store-sales category-stats)]
            [:td.u-text-nowrap
             (->
               (:cat-store-sales category-stats)
               (- (:cat-store-sales category-stats-prev))
               (/ (:cat-store-sales category-stats-prev))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (:cat-store-income category-stats-prev)))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (:cat-store-income category-stats)))]
            [:td.u-text-nowrap
             (->
               (:cat-store-income category-stats)
               (- (:cat-store-income category-stats-prev))
               (/ (:cat-store-income category-stats-prev))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap
             (->
               (:cat-store-income category-stats)
               (/ (if (= (:cat-income category-stats) 0) 1 (:cat-income category-stats)))
               (* 100)
               (yuc/number-format)
               (str "%"))]]
           [:tr.row-status
            [:td.u-min-width-320 [:b "Grand Total"]]
            [:td.u-text-nowrap (:cat-sales category-stats-prev)]
            [:td.u-text-nowrap (:cat-sales category-stats)]
            [:td.u-text-nowrap
             (->
               (:cat-sales category-stats)
               (- (:cat-sales category-stats-prev))
               (/ (:cat-sales category-stats-prev))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (:cat-income category-stats-prev)))]
            [:td.u-text-nowrap (str "R" (yuc/human-readable-currency (:cat-income category-stats)))]
            [:td.u-text-nowrap
             (->
               (:cat-income category-stats)
               (- (:cat-income category-stats-prev))
               (/ (:cat-income category-stats-prev))
               (* 100)
               (yuc/number-format)
               (str "%"))]
            [:td.u-text-nowrap "100%"]]]]])

      ;; Print Version of Stats
      (when (and category-stats (= page-type :print))
        [:div.stats-table-card.range-review-summary__stats.u-max-width-640.u-margin-bottom-40
         [:table.stats-table
          [:tbody
           [:tr.stats-table__row
            [:th.stats-table__th "Performance:"]
            [:td.stats-table__td.u-text-right "Total / Online / Stores"]]
           [:tr.stats-table__row
            [:th.stats-table__th "Income:"]
            [:td.stats-table__td.u-text-right
             (str "R" (yuc/human-readable-currency (:cat-income category-stats)) " / R"
               (yuc/human-readable-currency (- (:cat-income category-stats) (:cat-store-income category-stats))) " / R"
               (yuc/human-readable-currency (:cat-store-income category-stats))
               (when (and (:cat-store-income category-stats) (pos? (:cat-store-income category-stats)))
                 (str " (" (yuc/number-format (* (/ (:cat-store-income category-stats) (:cat-income category-stats)) 100) 2) "%)")))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Units Sold:"]
            [:td.stats-table__td.u-text-right
             (str (:cat-sales category-stats) " / "
               (- (:cat-sales category-stats) (or (:cat-store-sales category-stats) 0)) " / "
               (:cat-store-sales category-stats)
               (when (and (:cat-store-sales category-stats) (pos? (:cat-store-sales category-stats)))
                 (str " (" (yuc/number-format (* (/ (:cat-store-sales category-stats) (:cat-sales category-stats)) 100) 2) "%)")))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Avg. Margin:"]
            [:td.stats-table__td.u-text-right (str (:margin category-stats) "%")]]
           [:tr.stats-table__row
            [:th.stats-table__th (yuc/maybe assoc {:class [(when fetching-history? :u-text-red)]}) "Avg. Sellability:"]
            [:td.stats-table__td.u-text-right (when (and avg-sellability (pos? avg-sellability)) (str (yuc/number-format avg-sellability 2) "%"))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Contributions:"]
            [:td.stats-table__td.u-text-right (str/join " / " (:cats category-stats))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Income Contribution:"]
            [:td.stats-table__td.u-text-right (str/join " / " (map #(str % "%") (:income-contrib category-stats)))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Units Sold Contribution:"]
            [:td.stats-table__td.u-text-right (str/join " / " (map #(str % "%") (:sales-contrib category-stats)))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Growth:"]
            [:td.stats-table__td.u-text-right (str/join " / " (map #(str % (if % "%" "-")) growth))]]
           [:tr.stats-table__row
            [:th.stats-table__th "Ranging:"]
            [:td.stats-table__td.u-text-right "Online / Stores - (Proposed / Deranged)"]]
           [:tr.stats-table__row
            [:th.stats-table__th "Before:"]
            [:td.stats-table__td.u-text-right (str (count live-variations) " / " store-product-count " - ( - / - )")]]
           [:tr.stats-table__row
            [:th.stats-table__th "After:"]
            [:td.stats-table__td.u-text-right (str (+ (count live-variations) suggested-product-count) " / " (- (+ store-product-count proposed-product-count) store-remove-count) " - ( " proposed-product-count " / " store-remove-count " )")]]]]])]]))

(rum/defc product-list-pill [title colour & [text-colour]]
  [:div.td-text-pill-wrapper
   [:span
    {:class [(when text-colour (str "u-text-" (name text-colour))) (str "u-bg-" (name colour)) (yuc/bem :text-pill [:tiny])]}
    title]])